import { jsx as _jsx } from "react/jsx-runtime";
import { unifiedEmojiToString } from '#pplx/frontend/common/unifiedEmojiToString.js';
import React from 'react';
// Annoyingly, you can't dynamically generate these tailwind classnames
// because the tailwind compiler won't insert the definition in unless
// there's an exact text match in the code.
const SIZE_MAP = {
    xlarge: [64, 'h-[64px] w-auto leading-[64px]'],
    large: [48, 'h-[48px] w-auto leading-[48px]'],
    regular: [32, 'h-[32px] w-auto leading-[32px]'],
    medium: [24, 'h-[24px] w-auto leading-[24px]'],
    small: [18, 'h-[18px] w-auto leading-[18px]'],
    xsmall: [16, 'h-[16px] w-auto leading-[16px]'],
    tiny: [12, 'h-[12px] w-auto leading-[12px]'],
};
export const PerplexityEmoji = React.memo(function PerplexityEmoji({ unified, size, }) {
    const emoji = unified == null ? null : unifiedEmojiToString(unified);
    if (emoji == null)
        return null;
    const [numericSize, placeholderClassNames] = SIZE_MAP[size];
    return (_jsx("div", { className: `relative align-middle ${placeholderClassNames}`, children: _jsx("span", { className: "font-emoji", "data-unified": unified, style: {
                fontSize: numericSize,
                height: numericSize,
                letterSpacing: 0,
                lineHeight: '100%',
                position: 'relative',
                textAlign: 'center',
                width: numericSize,
            }, children: emoji }) }));
});
//# sourceMappingURL=PerplexityEmoji.js.map